import React from "react";
import DropdownList from "react-widgets/DropdownList";
import "./Container.css";

const DepInput = ({ setDepPort }) => {
  const updateDepPort = (depPort) => {
    console.log(depPort);
    setDepPort(depPort);
  };

  return (
    <div className="depinput">
      <DropdownList
        style={{ width: 450, fontSize: 15 }}
        onChange={updateDepPort}
        data={[
          "Gills Bay",
          "St. Margaret's Hope Ferry Terminal",
          "Oban",
          "Craignure",
        ]}
        placeholder={"Select starting port"}
      />
      <br />
    </div>
  );
};

export default DepInput;
